<template>
  <v-expand-transition>
    <v-card v-if="selectedUser" flat>

      <v-form ref="form" v-model="valid" :lazy-validation="lazy">
        <h5>NAMN OCH IDENTITET</h5>
        <v-row class="mt-6">
          <v-col cols="12" md="6">
            <v-text-field
              outlined
              label="Förnamn *"
              v-model="selectedUser.firstName"
              :rules="[rules.required]"
            />
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              outlined
              label="Efternamn *"
              v-model="selectedUser.lastName"
              :rules="[rules.required]"
            />
          </v-col>
        </v-row>

        <v-row class="mt-n4" v-if="$route.name == 'NewUser' || editField">
          <v-col cols="12" md="3">
            <v-text-field
              outlined              
              label="Personnummer *"
              v-model="selectedUser.personalNumber"
              :rules="[rules.required, rules.integer, rules.hasLength(12,selectedUser.personalNumber), rules.swePnr]"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row class="mt-n4" v-else>
          <v-col cols="12" md="3">
            <v-text-field
              outlined
              readonly
              append-icon="$sl-view-on"
              label="Personnummer *"
              @click:append="editField = true"
              v-model="maskedPersonalnumber"
            ></v-text-field>
          </v-col>
        </v-row>

        <h5>KONTAKTINFORMATION</h5>
        <v-row class="mt-n3">
          <v-col cols="12" md="6">
            <v-text-field
              outlined
              label="Mobiltelefon *"
              v-model="selectedUser.mobilephone"
              :rules="[rules.required]"
            />
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              outlined
              label="E-postadress *"
              v-model="selectedUser.email"
              :rules="[rules.required]"
            />
          </v-col>
        </v-row>

        <h5>POSTADRESS</h5>
        <v-row class="mt-n3">
          <v-col cols="12" md="6">
            <v-text-field
              outlined
              label="Adress *"
              v-model="selectedUser.address1"
              :rules="[rules.required]"
            />
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field outlined label="Adressrad 2 (frivillig)" v-model="selectedUser.address2" />
          </v-col>
        </v-row>
        <v-row class="mt-n4">
          <v-col cols="12" md="6">
            <v-row class="mt-n3">
              <v-col cols="12" md="3">
                <v-text-field
                  outlined
                  label="Postnummer *"
                  v-model="selectedUser.zip"
                  :rules="[rules.integer, rules.hasLength(5,selectedUser.zip)]"
                />
              </v-col>
              <v-col cols="9" md="9">
                <v-text-field
                  outlined
                  label="Ort *"
                  v-model="selectedUser.city"
                  :rules="[rules.required]"
                />
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" md="6">
            <v-select
              label="Land *"
              outlined
              :items="countries"
              item-value="key"
              item-text="value"
              v-model="selectedUser.country"
            />
          </v-col>
        </v-row>
        <v-card-actions class="justify-space-between no-margins mt-4">
          <v-btn :disabled="!canSave" @click="$emit('saveuser', selectedUser)">
            <v-icon>$sl-check</v-icon>Spara
          </v-btn>
        </v-card-actions>
      </v-form>

      <!--  <h5>FÖRETAGSKOPPLINGAR</h5>
     <v-data-table :headers="[]" :items="selectedUser" item-key="id">

      <template slot="item.lastName" slot-scope="props">
        <div>{{ props.item.firstName }} {{ props.item.lastName }}</div>
      </template>
      </v-data-table>-->
    </v-card>
  </v-expand-transition>
</template>

<script>
import AddressBox from '@/components/AddressBox.vue'
import API from '@/services/api.js'
import {mapGetters, mapActions} from 'vuex'
import {RulesMixin} from '@/components/mixins'
import {Countries} from '@/components/mixins'

// @group Person
export default {
  name: 'UserInformation',

  mixins: [RulesMixin, Countries],

  props: {
    // An array of the roles available for the v-select
    userRoles: {
      type: Array,
      // The default value is: `empty array`
      default: []
    },
    canSave: {
      type: Boolean,
      default: false
    },
    canDelete: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    valid: true,
    lazy: false,
    editField: false
  }),

  components: {
    AddressBox
  },
  created() {},
  computed: {
    ...mapGetters('user', ['selectedUser']),
    ...mapGetters('currentuser', ['currentUser', 'currentUserObj']),
    ...mapGetters('basic', ['basicRegions']),
    maskedPersonalnumber: {
      // getter
      get: function () {
        if (this.selectedUser && this.selectedUser.personalNumber && this.$route.name != 'NewUser') {
          return this.selectedUser.personalNumber.substring(0, 8) + '****'
        }
      },
      // setter
      set: function (newValue) {
        return newValue
      }
    }
  },

  methods: {
    ...mapActions('currentuser', ['setCurrentUser']),
    ...mapActions('user', ['setSelectedUser'])
  }
}
</script>

<style>
</style>